(function() {
    'use strict';

    angular
        .module('app.layout')
        .controller('routeCtrl', routeCtrl);

    /* @ngInject */
    function routeCtrl(
        $scope, $rootScope, $location, $routeParams, $window,dateFilter,
        $animate, $timeout, $sce, $http, json
        // $api $data smoothScroll
    ) {
        $scope.data = json.data;
        $rootScope.stats = json.data.stats;
        $rootScope.globals = json.data.globals;

        if ((typeof version == 'undefined') || (json.data.stats.version != version)) {
            version = json.data.stats.version;
            $window.location.reload(true);
        }

        $scope.trackingPixelFF = function() {
            if ($rootScope.project_has_opt('layoutFF')) {
                var ppid = '';
                switch($routeParams.reqUri) {
                    case '/': ppid = '4i4vwb0'; break;
                    // case '/': ppid = 'bp9djlb'; break;
                    // case '/': ppid = '4i4vwb0'; break;
                    case '/sponsors/': ppid = '6gyutud'; break;
                    case '/donate/': ppid = '9m2dais'; break;
                    case '/about-us/': ppid = 'd7aq7au'; break;
                    case '/get-involved/': ppid = 'gom9xxp'; break;
                    // case '/shopping-cart/': ppid = 'xpcuxzd'; break;
                    // case '/shopping-cart/': ppid = 'r4x047x'; break;
                    case '/shopping-cart/': ppid = 'iikf1dq'; break;
                    case '/about-slice-of-life/': ppid = 'wsyig4c'; break;
                    case '/shopping-cart-donate-thank-you/': ppid = 'dehuhnj'; break;
                    case '/shopping-cart-thank-you/': ppid = '7cwxx32'; break;
                    default: ppid = '';
                }

                var iHtml = '';

                if(ppid !== '') {
                    iHtml = '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=ptj30fy&ct=0:' + ppid + '&fmt=3"/>';
                    // console.log('routeCtrl', $routeParams.reqUri, ppid, iHtml);
                }

                iHtml += '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1252033435343202&ev=PageView&noscript=1"/>';

                if ($routeParams.reqUri == '/shopping-cart-thank-you/') {
                    iHtml += '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1252033435343202&ev=Purchase&noscript=1"/>';
                }

                return iHtml;

            } else {
                return '';
            }
        };

        $rootScope.openedNavbar = false;

        $rootScope.globals.default = {
            individualImg: typeof $scope.data.globals.site_options.seller_team_defaults.seller_avatar_placeholder !== 'undefined' ? $scope.data.globals.site_options.seller_team_defaults.seller_avatar_placeholder.url : '/wp-content/themes/pie/img/default-individual.png',
            teamImg: typeof $scope.data.globals.site_options.seller_team_defaults.team_avatar_placeholder !== 'undefined' ? $scope.data.globals.site_options.seller_team_defaults.team_avatar_placeholder.url : '/wp-content/themes/pie/img/default-team.png'
        };

        // ---
        angular.element('.overlay').removeClass('active');
        angular.element('link[rel="canonical"]').attr('href', $window.location);
        angular.element('meta[property="og:url"]').attr('content', $window.location);

        // ---
        // console.log('>>> customs', json.data);

        // angular.forEach($rootScope.globals.menu, function(item, idx) {
        //     // console.log([idx, item]);
        //     // $rootScope.globals.menu[idx].title = $sce.trustAsHtml(item.title);
        // });

        if($scope.data.stats && $scope.data.stats.page_title) {
            // console.log(['page_title', $scope.data.stats.page_title]);
            document.title = $scope.data.stats.page_title;
            angular.element('meta[property="og:title"]').attr('content', $scope.data.stats.page_title);
            angular.element('meta[property="og:description"]').attr('content', $scope.data.stats.page_description);
        }

        // if (// horror !!!
        //     angular.isDefined($scope.data.globals.site_options.google_tag_manager) &&
        //     angular.isDefined($scope.data.globals.site_options.google_tag_manager['tracking-id']) &&
        //     $scope.data.globals.site_options.google_tag_manager['tracking-id'] && !$scope.data.stats.is_404
        // ) {
        //     $window.gtag('config', $scope.data.globals.site_options.google_tag_manager['tracking-id'], {
        //         'page_location': $scope.data.query[0].link,
        //         'page_title': $scope.data.stats.page_title
        //     });
        // }

        $scope.selectTemplate = function() {
            if($scope.data.stats.name == 'mu-test') {return 'tests'; }
            if($scope.data.stats.is_home) { return 'home'; }
            // if($scope.data.stats.name == 'donate') { return 'donate'; }
            if($scope.data.stats.name == 'sponsors') { return 'sponsors'; }
            if($scope.data.stats.name == 'bakers') { return 'bakers'; }
            if($scope.data.stats.name == 'events') { return 'events'; }
            if($scope.data.stats.post_type == 'event') { return 'event'; }
            if($scope.data.stats.post_type == 'seller' && $scope.data.stats.is_tax == true && $scope.data.stats.is_archive == true) { return 'team'; }
            if($scope.data.stats.post_type == 'seller' && $scope.data.query[0].customs.seller_hq == true) { return 'seller-hq'; }
            // if($scope.data.stats.post_type == 'seller' && window.location.search.indexOf("hq") !== -1) { return 'seller-hq'; } //  TODO: hack for dev, remove this line
            if($scope.data.stats.post_type == 'seller') { return 'seller'; }
            if($scope.data.stats.name == 'sellers') { return 'sellers'; }
            //if($scope.data.stats.post_type == 'seller-team') { return 'sellers'; }
            if($scope.data.stats.name == 'test-form') { return 'test-form'; }
            // if($scope.data.stats.name == 'test-sections') { return 'test-sections'; }
            // if($scope.data.stats.name == 'test-sections-2') { return 'tests'; }
            if($scope.data.stats.name == 'contacts-test') { return 'contacts-test'; }
            if($scope.data.stats.name == 'pickup-locations') { return 'pickup-locations'; }
            if($scope.data.stats.name == 'shopping-cart') { return 'shopping-cart'; }
            if($scope.data.stats.name == 'donate') { return 'donate'; }
            if($scope.data.stats.name == 'bulk-gifts') { return 'bulk-gifts'; }
            if($scope.data.stats.is_page) { return 'pie-sections'; }
            if($scope.data.stats.is_404) { return '404'; }
            // if($scope.data.stats.is_single && $scope.data.stats.post_type == 'cases') { return 'case'; }
            // if($scope.data.stats.name == 'new-york-web-design-firm-services') { return 'services'; }
            // if($scope.data.stats.name == 'new-york-website-design-company-case-studies') { return 'cases'; }
            // if($scope.data.stats.name == 'new-york-web-design-agency-creative-development-process') { return 'process'; }
            // if($scope.data.stats.name == 'new-york-website-design-company-award-winning-team') { return 'our-team'; }
            // if($scope.data.stats.name == 'new-york-web-design-nonprofit-crm') { return 'limus-crm'; }
            // if($scope.data.stats.name == 'contact') { return 'contact-us'; }
            // if($scope.data.stats.post_type == 'marketing') { return 'marketing'; }
            return 'unknown';
        };
        /*
        if ((angular.isDefined($scope.$root.stats.requiredLogin) || angular.isDefined($scope.$root.stats.loginFormTab)) && !$scope.$root.stats.current_user) {
            $scope.$root.openModal('login-form');
        }
        */
        if (angular.isDefined($scope.$root.stats.requiredLogin)  && !$scope.$root.stats.current_user) {
            $scope.$root.openModal('login-form');
        }

        $rootScope.loadGoogleMap = function(callback) {
            var url = 'https://maps.googleapis.com/maps/api/js?key=' + $scope.data.globals.site_options.maps.api_key;
            var type = 'text/javascript';
            var head = document.getElementsByTagName("head")[0];
            var script = document.querySelector("script[src*='" + url + "']");
            if (!script) {
                script = Object.assign(document.createElement('script'), {
                    src: url,
                    type: type,
                    onload: callback
                });
                head.appendChild(script);
            }
            // var s = document.createElement("script");
            // s.setAttribute("src", 'https://maps.googleapis.com/maps/api/js?key=' + $scope.data.globals.site_options.maps.api_key);
            // document.head.appendChild(s);
            // s.onload = callback;
        };

        $rootScope.loadPaymentScript = function() {
            window.paymentProcessor = $rootScope.globals.site_options.payment;
            var url = $rootScope.globals.site_options.payment.scriptUrl;
            var type = 'text/javascript';
            var head = document.getElementsByTagName("head")[0];
            var script = document.querySelector("script[src*='" + url + "']");
            if (!script) {
                script = Object.assign(document.createElement('script'), {
                    src: url,
                    type: type
                });
                head.appendChild(script);
            } else {
                setTimeout(function () {
                    window.initPayment();
                    // window.adjust();
                }, 1000);
            }
        };


        $rootScope.packHours = function(pickupHours) {
            var packed = {};
            pickupHours.forEach(function(e) {
                var day =  $rootScope.safeChain(e, 'day', 0);
                var from = $rootScope.safeChain(e, 'time-from', 0);
                var to =   $rootScope.safeChain(e, 'time-to', 0);
                if (!packed[day]) {
                    packed[day] = [];
                }
                packed[day].push({from: from , to: to});
            });
            return packed;
        };

        $rootScope.formatHours = function(params, ends) {
            // if (params && params.length > 1) {
            //     console.log(params, ends);
            // }
            var output = '';
            if (!angular.isArray(params)) {
                return output;
            }
            var packed = $rootScope.packHours(params);
            // if (params && params.length > 1) {
            //     console.log(packed);
            // }
            for (var d in packed) {
                output += dateFilter(new Date(d * 1000),'EEEE, MMMM d') + '<br>';

                if (!ends) {
                    for(var j = 0 ; j < packed[d].length; j++) {
                        output += dateFilter(new Date(packed[d][j].from * 1000), "h:mm a") + ' - ' +  dateFilter(new Date(packed[d][j].to) * 1000, "h:mm a") + '<br>';
                    }
                } else {
                    output +=  dateFilter(new Date(packed[d][0].from * 1000), 'h:mm a') + ' - ' +  dateFilter(new Date(packed[d][packed[d].length - 1].to * 1000), 'h:mm a') + '<br>';
                }
                // if (!ends) {
                //     output = output.slice(0, -2);
                // }
            }
            return output;
        };

        $rootScope.safeChain = function(base, chainStr, fallback) {
            var p = base;
            var chainArr = chainStr.split(/\s*,\s*/);
            for (var i = 0; i < chainArr.length; i++) {
                if (p && p.hasOwnProperty(chainArr[i]) && angular.isDefined(p[chainArr[i]])) {
                    p = p[chainArr[i]];
                } else {
                    return fallback || '';
                }
            }
            return p;
        };

        $rootScope.isEmptyObject = function(o) {
            return ((typeof o === 'object') && (Object.keys(o).length === 0) && Object.getPrototypeOf(o) === Object.prototype);
        };

        $rootScope.checkChain = function(base,chainStr) {
            var p = base;
            var chainArr = chainStr.split(',');
            for (var i = 0; i < chainArr.length; i++) {
                if (angular.isDefined(p) && p.hasOwnProperty(chainArr[i])) {
                    p = p[chainArr[i]];
                } else {
                    return false;
                }
            }
            return true;
        };
        $rootScope.project_has_opt = function(opt) {
            return $scope.data.globals.site_options.shopping_cart_settings.opts.indexOf(opt) == -1 ? false : true;
        };

        $rootScope.getField = function(fields, path) {
            var find  = function(e) {
                return e.name == p;
            };
            var f, p;
            var base = fields;
            while(path.length > 0) {
                p = path.shift();
                f = base.find(find);
                if (!f) {
                    return false;
                }
                if (f.fields) {
                    base = f.fields;
                }
            }
            return f;
        };

        if (!$scope.data.stats.is_404 && $rootScope.safeChain($scope.data.query[0].customs, 'banner,hide_menu,value')) {
            angular.element('.mobile-only-buttons').hide();
        } else {
            angular.element('.mobile-only-buttons').show();
        }

        if ((window.location.href.indexOf('shopping-cart') != -1)  && $scope.project_has_opt('scWizard')) {
            $scope.loadGoogleMap();
        }

        // Hide buttons --

        $rootScope.hideButtons = function() {
            var buttons = document.querySelectorAll('.menu-buttons .b-wrap, .mobile-only-buttons');
            if (buttons.length < 2) {
                setTimeout($rootScope.hideButtons, 100);
            }
            var slugs = ['shopping-cart', 'donate'];
            if ($scope.$root.rsp.apn.chk) {
                slugs.push('');
            }
            var page = window.location.pathname.replaceAll('/', '');
            buttons.forEach(function(e) {
                if (slugs.indexOf(page) != -1) {
                    e.style.setProperty('display', 'none', 'important');
                } else {
                    e.style.setProperty('display', 'inherit');
                }
            });
        };

        if ($rootScope.project_has_opt('layoutCS') && $scope.$root.rsp.apn.chk) {
            $rootScope.hideButtons();
        }

        // ---

        if ($rootScope.project_has_opt('layoutCS')) {
            window.preSubmit = function(resume) {
                if ($rootScope.stats.name != 'seller-sign-up') {
                    window.preSubmitted = true;
                    return false;
                }
                var cellNumber = document.querySelector('input[name="phone"]').value;
                if (!cellNumber) {
                    return false;
                }

                if (window.preSubmitted) {
                    return false;
                }

                $rootScope.is_askNumber = true;
                $rootScope.askNumber = {
                    text: 'Is your cell phone number ' + cellNumber + ' up to date?',
                    buttons: [
                        {
                            text: 'Yes, it is current',
                            callback: function() {
                                resume();
                                setTimeout(function() {
                                    $rootScope.is_askNumber = false;
                                    $rootScope.$apply(function() {
                                        $rootScope.modalContent = '';
                                    });
                                }, 10);
                                document.querySelector('.overlay').classList.remove('active');
                            }
                        },
                        {
                            text: 'Update number',
                            callback: function() {
                                setTimeout(function() {
                                    $rootScope.is_askNumber = false;
                                    $rootScope.$apply(function() {
                                        $rootScope.modalContent = '';
                                    });
                                }, 10);
                                setTimeout(function() {
                                    document.querySelector('input[name="phone"]').focus();
                                }, 100);
                                document.querySelector('.overlay').classList.remove('active');
                            }
                        }
                    ]
                };
                $rootScope.openModal("info-modal");
                window.preSubmitted = true;

                return true;
            };
        }

    }

})();